import { useCallback, useEffect, useState } from "react";
import { selectionHistoryApi } from "src/Api/selectionHistory";

export function useGroupSelectionHistories(userId: number) {
  const [groupList, setGroupList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  if (!userId || userId === 0 ) return; 
  }, [userId]);

  // GET
  const fetchGroupList = useCallback(() => {
    if (!userId) return;
    setLoading(true);
    selectionHistoryApi.getGroupSelectionHistories(userId)
      .then(res => setGroupList(res.data.data))
      .finally(() => setLoading(false));
  }, [userId]);

  useEffect(() => { fetchGroupList(); }, [fetchGroupList]);

  // POST（保存&リスト取得）
  const storeGroupSelection = useCallback(async (body: any) => {
    await selectionHistoryApi.storeGroupSelectionHistory(body);
    fetchGroupList(); // 保存後に最新リスト再取得
  }, [fetchGroupList]);

  return { groupList, loading, storeGroupSelection, fetchGroupList };
}
